import { Link } from "react-router-dom";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageFatherC.module.scss";

function PageFatherC() {
  const getImgSet = useImgSet();

  const description = getImgSet("description__p24", "png", s.description);
  const item01 = getImgSet("item__01__p24", "png", [s.item, s.item__01]);
  const item02 = getImgSet("item__02__p24", "png", [s.item, s.item__02]);
  const pointer = getImgSet("pointer__father", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__01", "png", s.img__a);

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>{imgA}</div>
      <div className={s.inner}>
        {item01}
        {item02}
      </div>
      <div className={s.aside_right}>
        <Link to="/father/" className={s.back}>
          {back}
        </Link>
        {description}
      </div>
    </div>
  );
}

export default withLayoutOptions(PageFatherC);
